import { render, staticRenderFns } from "./InvoicesPageV2.vue?vue&type=template&id=1ddafac5&scoped=true"
import script from "./InvoicesPageV2.vue?vue&type=script&lang=js"
export * from "./InvoicesPageV2.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPageV2.vue?vue&type=style&index=0&id=1ddafac5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddafac5",
  null
  
)

export default component.exports